import { createRootRoute, Outlet } from '@tanstack/react-router';

export const Route = createRootRoute({
  component: () => <Outlet />,
  notFoundComponent: () => (
    <div className="flex h-full items-center justify-center text-sm text-slate-500">
      Seite nicht gefunden.
    </div>
  ),
});
